'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const index = require('./index.js');
const utils = require('./utils.js');

function useCreateMotionContext(props, isStatic) {
  var _a = utils.getCurrentTreeVariants(props, React.useContext(index.MotionContext)),
    initial = _a.initial,
    animate = _a.animate;
  return React.useMemo(function () {
    return {
      initial: initial,
      animate: animate
    };
  },
  /**
   * Only break memoisation in static mode
   */
  isStatic ? [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate)] : []);
}
function variantLabelsAsDependency(prop) {
  return Array.isArray(prop) ? prop.join(" ") : prop;
}

exports.useCreateMotionContext = useCreateMotionContext;
